import { Num } from "@/components/common/ui";
import { fmtDate, packInfo } from "@/lib/format";
import { cn } from "@/lib/utils";

const Qty = ({ v, p, bold }) => (
  <div className={cn("num text-right", v < 0 && "font-bold text-brand", bold && "font-bold")}>
    {v}{v < 0 && <span className="ml-1 rounded bg-brand px-1 text-[9px] text-white">!</span>}
    {packInfo(v, p) && <div className="text-[10px] font-normal text-zinc-500">{packInfo(v, p)}</div>}
  </div>
);

function GroupHeader({ p, onPick }) {
  return (
    <div className="flex items-baseline gap-2 px-1 pb-2 pt-6">
      <button onClick={() => onPick(p.id)} className="font-display text-base font-bold text-brand underline-offset-4 hover:underline" data-testid={`kartu-group-${p.code}`}>
        [{p.code}] {p.name}
      </button>
      <span className="text-xs text-zinc-500">{p.category} · {p.stock_unit}</span>
    </div>
  );
}

export function DetailTables({ data, onOpen, onPick }) {
  return data.groups.map(({ product: p, rows, subtotal: s }) => (
    <section key={p.id}>
      <GroupHeader p={p} onPick={onPick} />
      <div className="overflow-x-auto rounded-lg border border-zinc-200 bg-white">
        <table className="dense-table w-full min-w-[1100px]" data-testid={`kartu-table-${p.code}`}>
          <thead><tr><th>Tanggal</th><th>Tipe Transaksi</th><th>No. Transaksi</th><th>Keterangan</th><th className="text-right">Qty Awal</th><th className="text-right">Produksi</th>
            <th className="text-right">Purchase</th><th className="text-right">Penjualan</th><th className="text-right">Adjustment</th><th className="text-right">Waste</th><th className="text-right">Qty Akhir</th><th>Gudang</th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className={r.is_reversal ? "italic text-zinc-500" : ""}>
                <td>{fmtDate(r.date)}</td><td>{r.tipe}</td>
                <td><button onClick={() => onOpen(r.txn_id)} className="num font-semibold text-brand underline-offset-2 hover:underline" data-testid={`kartu-txn-${r.txn_no}`}>{r.txn_no}</button></td>
                <td className="max-w-[320px] truncate" title={r.keterangan}>{r.keterangan}</td>
                <td><Qty v={r.qty_awal} p={p} /></td>
                {["produksi", "purchase", "penjualan", "adjustment", "waste"].map((c) => <td key={c} className="text-right">{r[c] ? <Num value={r[c]} /> : ""}</td>)}
                <td><Qty v={r.qty_akhir} p={p} bold /></td><td>{r.gudang}</td>
              </tr>
            ))}
            <tr className="bg-zinc-100 font-bold" data-testid={`kartu-subtotal-${p.code}`}>
              <td colSpan={4}>{rows.length ? `Subtotal · ${rows.length} transaksi` : "Tidak ada transaksi di periode ini"}</td>
              <td><Qty v={s.qty_awal} p={p} bold /></td>
              {["produksi", "purchase", "penjualan", "adjustment", "waste"].map((c) => <td key={c} className="text-right"><Num value={s[c]} /></td>)}
              <td><Qty v={s.qty_akhir} p={p} bold /></td><td>Pusat</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  ));
}

export function DailyTables({ data, onPick }) {
  const cols = [["produksi", "+Produksi"], ["purchase", "+Purchase"], ["penjualan_sales", "−Sales"], ["penjualan_sample", "−Sample"], ["penjualan_endorse", "−Endorse"], ["waste", "−Waste"], ["adjustment", "±Adj"]];
  return data.groups.map(({ product: p, rows, subtotal: s }) => (
    <section key={p.id}>
      <GroupHeader p={p} onPick={onPick} />
      <div className="overflow-x-auto rounded-lg border border-zinc-200 bg-white">
        <table className="dense-table w-full min-w-[900px]" data-testid={`kartu-daily-${p.code}`}>
          <thead><tr><th>Tanggal</th><th className="text-right">Qty Awal (stok pagi)</th>{cols.map(([k, l]) => <th key={k} className="text-right">{l}</th>)}<th className="text-right">Qty Akhir</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.date}><td>{fmtDate(r.date)}</td><td><Qty v={r.qty_awal} p={p} /></td>
                {cols.map(([k]) => <td key={k} className="text-right">{r[k] ? <Num value={r[k]} /> : <span className="text-zinc-300">0</span>}</td>)}
                <td><Qty v={r.qty_akhir} p={p} bold /></td></tr>
            ))}
            <tr className="bg-zinc-100 font-bold"><td>Periode</td><td><Qty v={s.qty_awal} p={p} bold /></td>
              <td className="text-right"><Num value={s.produksi} /></td><td className="text-right"><Num value={s.purchase} /></td>
              <td colSpan={3} className="text-right"><Num value={s.penjualan} /></td><td className="text-right"><Num value={s.waste} /></td>
              <td className="text-right"><Num value={s.adjustment} /></td><td><Qty v={s.qty_akhir} p={p} bold /></td></tr>
          </tbody>
        </table>
      </div>
    </section>
  ));
}
